import { useEffect, useRef, useState } from "react";

const TypedText = ({ text, delay = 50, start = true, onComplete, className }) => {
    const [currentText, setCurrentText] = useState('');
    const [hasCompleted, setHasCompleted] = useState(false);
    const indexRef = useRef(0);
    const timeoutRef = useRef(null);
  
    useEffect(() => {
        if (!start) return;
      
        setCurrentText('');
        indexRef.current = 0;
        setHasCompleted(false);
      
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      
        const typeNextChar = () => {
          const nextIndex = indexRef.current;
          if (nextIndex < text.length) {
            setCurrentText(prev => prev + text.charAt(nextIndex));
            indexRef.current += 1;
            timeoutRef.current = setTimeout(typeNextChar, delay);
          } else {
            setHasCompleted(true);
            if (onComplete) onComplete();
          }
        };
      
        timeoutRef.current = setTimeout(typeNextChar, delay);
      
        return () => {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
      }, [text, delay, start]);
  
    return <h2 className={className}>{hasCompleted ? text : currentText}</h2>;
  };
  
  export default TypedText